var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3.2 1a1 1 0 0 1 .117 1.993L3.2 3H3v3a2 2 0 0 0 1.85 1.995L5 8a2 2 0 0 0 1.995-1.85L7 6V3h-.2a1 1 0 0 1-.993-.883L5.8 2a1 1 0 0 1 .883-.993L6.8 1H8a1 1 0 0 1 .993.883L9 2v4a4.002 4.002 0 0 1-3.007 3.876v.007L6 10a3 3 0 0 0 5.995.176L12 10V7.792a2.5 2.5 0 1 1 2 0V10a5 5 0 0 1-10 0c0-.042.003-.084.008-.125A4 4 0 0 1 1.005 6.2L1 6V2a1 1 0 0 1 .883-.993L2 1h1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.45215b5b164a807e63957acf9e1f046a.svg";
export { ForwardRef as ReactComponent };